// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnIcon {
  text-align: center;
}

ion-input {
  position: relative;
  z-index: 1000; /* Ensure the input is above other elements */
}

.addressSuggestion {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  background-color: rgb(245, 245, 245);
  margin: 2px;
  border-radius: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/address/form-address/from-address.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEE;EACE,kBAAA;EACA,aAAA,EAAA,6CAAA;AACJ;;AAEE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AACJ","sourcesContent":[".btnIcon {\r\n    text-align: center;\r\n  }\r\n\r\n  ion-input {\r\n    position: relative;\r\n    z-index: 1000; /* Ensure the input is above other elements */\r\n  }\r\n\r\n  .addressSuggestion{\r\n    display: flex; \r\n    justify-content: center;\r\n    align-items: center; \r\n    width: 100%; \r\n    height: fit-content;\r\n    background-color: rgb(245, 245, 245);\r\n    margin: 2px;\r\n    border-radius: 5px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    padding-right: 3px;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
